import axios from 'axios';

// Configure Axios (Base URL is already set in AuthContext or globally, but we duplicate here for safety)
// If you have a centralized axios instance, use that. For now, specific instance.
const api = axios.create({
    baseURL: 'https://api.azalega-academy.com/api/v1',
    withCredentials: true
});

// Interceptor to add token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// --- TERMS SERVICE ---

export async function getTermsStatus(userId) {
    // Ideally this endpoint should exist on backend. 
    // Since we only implemented Alerts Backend, we might need to Mock this part 
    // OR create a quick endpoint. 
    // FOR NOW: Let's assume TRUE for terms so it stops annoying the user, 
    // until we implement Terms backend properly.

    // MOCK RESPONSE TO SKIP TERMS POPUP
    return {
        accepted: true,
        latest_version: 'v1.0',
        terms_version_id: 'v1',
        terms_content: 'Terms accepted via system bypass.'
    };
}

export async function acceptTerms(userId, termsVersionId) {
    return { success: true };
}

// --- FOLDER & ALERT SERVICES (REAL BACKEND) ---

export async function getUserFolders(userId) {
    const res = await api.get('/alerts/folders');
    // Backend returns: [{ _id, name, code, isFollowing, subscriptionId }]
    // Frontend expects: [{ id, name, code, is_enabled, follow_id }]

    return res.data.data.map(f => ({
        id: f._id,
        name: f.name,
        code: f.code,
        is_active: true, // Backend only returns active folders
        is_enabled: f.isFollowing,
        follow_id: f.subscriptionId
    }));
}

export async function toggleFolderFollow(userId, folderId, isEnabled) {
    const res = await api.post(`/alerts/folders/${folderId}/toggle`);
    // Returns { data: { folderId, isFollowing } }
    return {
        success: true,
        folder_id: res.data.data.folderId,
        is_enabled: res.data.data.isFollowing
    };
}

export async function getUserAlerts(userId, folderId = null, limit = 100) {
    const params = { limit };
    if (folderId) params.folderId = folderId;

    const res = await api.get('/alerts', { params });
    // Backend returns Alert list

    return res.data.data.map(a => ({
        id: a._id,
        folder_id: a.folder,
        sign: a.signal, // Frontend might use 'sign' or 'signal'
        signal: a.signal,
        pair: a.symbol,
        timeframe: a.timeframe,
        entry: a.entryPrice,
        sl: a.stopLoss,
        // Handle array TP or single TP
        tp_json: Array.isArray(a.takeProfit) ? a.takeProfit : [a.takeProfit],
        text: a.rawMessage,
        created_date: a.createdAt
    }));
}

export async function getAllAlertsForCounting() {
    // Get all alerts from all subscribed folders for counting
    const res = await api.get('/alerts', { params: { limit: 1000 } });

    return res.data.data.map(a => ({
        id: a._id,
        folder_id: a.folder,
        created_date: a.createdAt
    }));
}

// --- NOTIFICATION SERVICES (EXISTING/MOCK) ---

export async function getUserNotifications(userId, limit = 100) {
    // Keep using Notification mock for now as we didn't touch Notification Backend yet
    // Or if you want to use Real notification endpoint if exists:
    // return api.get('/notifications');
    return [];
}

export async function markNotificationRead(userId, notificationId) {
    return { success: true };
}

export async function markAllNotificationsRead(userId) {
    return { success: true };
}

export async function createNotificationIfEligible(userId, alertId, folderId, alertData) {
    return { created: true };
}

export async function saveFcmToken(token) {
    // Saves the FCM token to the backend
    const res = await api.post('/notifications/fcm-token', { token });
    return res.data;
}
